import { linkPath } from 'common/constants';

// One allowlist for every way a link can reach the app: universal links,
// custom-scheme links and push taps. Anything off the list resolves to null,
// so a non-match is a silent no-op. Keep in sync with server.js
// UNIVERSAL_LINK_PATHS (that file is plain Node, so the list is duplicated).

export const UNIVERSAL_LINK_HOSTS = ['app.doqit.io', 'doqit-react-uat.herokuapp.com'];
// Backend placeholder host for offer links. Not in the AASA list: it is only
// accepted here, for links that reach us some other way (push payloads).
const OFFER_LINK_HOST = 'www.doqit.io';
const SCHEME_PROTOCOLS = ['doqit:', 'doqit-app:'];
export const OFFER_SLUGS = ['rescue', 'monthly', 'annual-switch', 'renewal-save', 'winback'];

const STATIC_PATHS = [
  '/dashboard',
  '/reminders',
  '/document/upload',
  '/my-sharing',
  '/shared-with-me',
  linkPath.searchDocumentPath,
  linkPath.documentList,
  '/learn',
];

const isAllowedPath = (pathname: string): boolean => {
  if (STATIC_PATHS.includes(pathname)) return true;
  if (/^\/editDocuments\/\d+$/.test(pathname)) return true;
  if (/^\/learn\/[a-z0-9-]{1,40}$/.test(pathname)) return true;
  const offer = /^\/offer\/([a-z-]+)$/.exec(pathname);
  return !!offer && OFFER_SLUGS.includes(offer[1]);
};

const withToken = (pathname: string, params: URLSearchParams): string => {
  const token = params.get('token');
  return token ? `${pathname}?token=${encodeURIComponent(token)}` : pathname;
};

export const resolveInAppPath = (input: string): string | null => {
  if (typeof input !== 'string' || !input) return null;
  try {
    let pathname: string;
    let params: URLSearchParams;
    if (input.startsWith('/') && !input.startsWith('//')) {
      const parsed = new URL(input, 'https://app.doqit.io');
      pathname = parsed.pathname;
      params = parsed.searchParams;
    } else {
      const parsed = new URL(input);
      if (parsed.protocol === 'https:') {
        const isOfferHost = parsed.hostname === OFFER_LINK_HOST && parsed.pathname.startsWith('/offer/');
        if (!UNIVERSAL_LINK_HOSTS.includes(parsed.hostname) && !isOfferHost) return null;
        pathname = parsed.pathname;
      } else if (SCHEME_PROTOCOLS.includes(parsed.protocol)) {
        // doqit://offer/rescue has hostname 'offer' and pathname '/rescue'.
        if (parsed.hostname !== 'offer' && parsed.hostname !== 'learn') return null;
        pathname = `/${parsed.hostname}${parsed.pathname}`.replace(/\/+$/, '');
      } else {
        return null;
      }
      params = parsed.searchParams;
    }
    return isAllowedPath(pathname) ? withToken(pathname, params) : null;
  } catch {
    return null;
  }
};
